import React, { useCallback } from "react";
import "@awsui/global-styles/index.css"
import Grid from "aws-northstar/layouts/Grid";
import ConnectCCP from "./ConnectCCP";
import CustomerInfo from "./CustomerInfo";

const Dashboard = () => {
  console.log("Dashboard");
  // Avoid re-rendering ConnectCCP
  const CCP = useCallback(() => <ConnectCCP />, []);

  return (
    <>
      <Grid container spacing={1} direction="row">
        <Grid item xs>
          <CCP />
        </Grid>
        <Grid item xs>
          <CustomerInfo />
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
